<template>
  <van-radio-group v-model="value" class="collect-form-item-radio" :disabled="readonly">
    <van-radio v-for="(option, index) in item.options" :key="index" :name="option.value">
      <span class="collect-form-item-radio-option-label">{{ option.label }}</span>
      <input
        v-if="item.value === 'other' && option.other"
        v-model="item.otherText"
        class="collect-form-item-option-other-input"
        maxlength="200"
        :disabled="readonly"
      />
      <OptionImage :option="option"></OptionImage>
    </van-radio>
  </van-radio-group>
</template>

<script>
import OptionImage from "./OptionImage";

export default {
  components: { OptionImage },
  props: ["item", "readonly", "row"],
  data() {
    return {
      value: this.row ? this.row.value : this.item.value,
    };
  },
  watch: {
    value: function (val) {
      if (this.row) {
        this.$set(this.row, "value", val);
      } else {
        this.$set(this.item, "value", val);
      }
    },
  },
  created() {},
  methods: {},
};
</script>
<style scoped>
</style>